/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */
import { Theme, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    identityProviderWrap: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    identityProviderText: {
      color: theme.palette.secondary.main,
    },
    identityProviderImageWrap: {
      maxWidth: theme.spacing(17),
      width: '100%',
      marginTop: theme.spacing(2),
    },
    identityProviderImage: {
      width: '100%',
      maxWidth: '100%',
      height: 'auto',
    },
  })
);

export default useStyles;
